module.exports = __webpack_public_path__ + "img/img_finannee.29c98bdd.jpg";